<template>
  <base-picture
    v-if="images"
    v-bind="images"
    :class="className"
    :fit
    :lazy
    :props-img="imgProps"
  />
  <vf-video
    v-else
    v-bind="video"
    ref="videoRef"
    :autoplay="!lazy"
    :class="className"
    :fit
    loop
    :meta="video?.meta?.sm"
    muted
  />
</template>

<script lang="ts" setup>
import type { ImgHTMLAttributes } from '#types/components/base/picture'
import type { ResponsiveMedia } from '#types/content'

const { media, propsImg, fit = 'cover' } = defineProps<{
  className?: string | (string | Record<string, boolean>)[]
  controls?: boolean
  fit?: 'contain' | 'cover'
  lazy?: boolean
  media: ResponsiveMedia
  propsImg?: ImgHTMLAttributes
}>()

const { getMedia } = useCms()

const videoRef = ref<HTMLVideoElement>()

const { images, video } = (media && getMedia(media)) || {} as ResponsiveMedia

const imgProps = { class: 'h-full', ...propsImg }

onMounted(() => videoRef.value?.play().catch((e) => log.error(e)))
</script>
